(function SearchAddTraveler($, Adzuki)
{
	"use strict";

	var SearchAddTraveler = {};

	var _buildSelectedTravelers,
	    _removeSelectedTraveler,
	    _removeSelectedTravelerByClientId,
	    _resetSelectedTravelers;

	var $form,
	    $parent_form,
	    travelers    = [],
	    drake        = null;

	SearchAddTraveler.addTraveler = function addTraveler(new_traveler)
	{
		var already_exists = false,
		    name_chunks;

		$.each(travelers, function iterator(i, traveler) {
			if (typeof traveler !== 'undefined' && traveler['client_id'] === new_traveler['client_id']) {
				already_exists = true;

				return false;
			}
		});

		if (already_exists) {
			return;
		}

		if (new_traveler['name'].indexOf('@') !== -1) {
			name_chunks = new_traveler['name'].split(' - ');
			name_chunks.pop();

			new_traveler['name'] = name_chunks.join(' - ');
		}

		travelers.push(new_traveler);

		_buildSelectedTravelers();
	};

	SearchAddTraveler.buildRecommendedTravelers = function buildRecommendedTravelers(recommended_travelers)
	{
		var html,
		    per_column_count,
		    checked,
		    j;

		$.each(travelers, function iterator(i, traveler) {
			if (typeof traveler !== 'undefined' && traveler['type'] === 'recommended') {
				delete travelers[i];
			}
		});

		if (typeof recommended_travelers === 'undefined' || recommended_travelers.length === 0) {
			$form.find('.recommended-travelers').addClass('hidden');
			$form.find('.recommended-traveler-list').html('');

			_buildSelectedTravelers();

			return;
		}

		per_column_count = Math.round(recommended_travelers.length / 3);

		if (per_column_count < 1) {
			per_column_count = 1;
		}

		html  = '<div class="row">\n';
		html += '	<div class="col-sm-4">\n';

		j = 1;

		$.each(recommended_travelers, function iterator(i, recommended_traveler) {
			if (recommended_traveler['primary_client'] === 1) {
				SearchAddTraveler.addTraveler({
					type     : 'recommended',
					client_id: recommended_traveler['id'].toString(),
					name     : recommended_traveler['name'],
				});

				checked = ' CHECKED';
			} else {
				checked = '';
			}

			html += '		<div class="checkbox">\n';
			html += '			<label class="width-auto">\n';
			html += '				<input type="checkbox" class="recommended-traveler" value="' + recommended_traveler['id'] + '" data-name="' + Adzuki.String.sanitize(recommended_traveler['name']) + '"' + checked + '>&nbsp;&nbsp;' + Adzuki.String.sanitize(recommended_traveler['name']) + '\n';
			html += '			</label>\n';
			html += '		</div>\n';

			if (j === per_column_count) {
				html += '	</div>\n';
				html += '	<div class="col-sm-4">\n';

				j = 1;
			} else {
				j++;
			}
		});

		html += '	</div>\n';
		html += '</div>\n';

		$form.find('.recommended-traveler-list').html(html);
		$form.find('.recommended-travelers').removeClass('hidden');

		$form.find('.recommended-traveler').on('change', function change(e) {
			var $recommended_traveler = $(e.target);

			if ($recommended_traveler.is(':checked')) {
				SearchAddTraveler.addTraveler({
					type     : 'recommended',
					client_id: $recommended_traveler.val(),
					name     : $recommended_traveler.data('name'),
				});
			} else {
				_removeSelectedTravelerByClientId($recommended_traveler.val());
			}
		});
	};

	SearchAddTraveler.init = function init(parent_form_name)
	{
		$form        = $('form[name="ReservationSearchAddTraveler"]');
		$parent_form = $('form[name="' + parent_form_name + '"]');

		// Check All and Un-check All options
		$(".recommended-travelers").on("click", ".toggle-all", function checkAll(event)
		{
			var $self       = $(this),
			    $parent     = $self.parents('.recommended-travelers'),
			    $checkboxes = $parent.find('.recommended-traveler-list').find(':checkbox');

			event.preventDefault();

			$checkboxes.each(function eachCheck(i, ele) {
				var $check = $(this);

				if ($self.hasClass('check-all')) {
					$check.prop('checked', true);

					SearchAddTraveler.addTraveler({
						type     : 'recommended',
						client_id: $check.val(),
						name     : $check.data('name'),
					});
				} else {
					$check.prop('checked', false);
					_removeSelectedTravelerByClientId($check.val());
				}
			});
		});
	};

	SearchAddTraveler.resetRecommendedTravelers = function resetRecommendedTravelers()
	{
		SearchAddTraveler.buildRecommendedTravelers();
	};

	_buildSelectedTravelers = function _buildSelectedTravelers()
	{
		var traveler_count      = 1,
		    spcid_html          = '',
		    $selected_travelers,
		    sp_html,
		    parent_form_name;

		$selected_travelers = $form.find('.selected-travelers');
		parent_form_name    = $parent_form.attr('name');

		sp_html  = '<span class="recipient remove-all" id="remove-all">\n';
		sp_html += '	<span data-toggle="tooltip" data-placement="right" title="" data-original-title="Remove All">\n';
		sp_html += '		<i class="'+Adzuki.FaIcon.getIconStyle('delete')+'"></i>\n';
		sp_html += '	</span>\n';
		sp_html += '</span>\n';

		$.each(travelers, function iterator(i, traveler) {
			if (typeof traveler !== 'undefined') {
				sp_html += '<span class="recipient draggable">\n';
				sp_html += '	<span class="remove" data-type="' + traveler['type'] + '" data-client-id="' + traveler['client_id'] + '" data-name="' + Adzuki.String.sanitize(traveler['name']) + '"><i class="'+Adzuki.FaIcon.getIconStyle('close')+'"></i></span>\n';
				sp_html += '	<span class="title"><strong>Traveler ' + traveler_count + ':</strong> ' + Adzuki.String.sanitize(traveler['name']) + '</span>\n';
				sp_html += '</span>\n';

				spcid_html += '<input type="hidden" name="form_component_data[' + parent_form_name + '][selected_travelers][]" value="' + traveler['client_id'] + '">\n';

				traveler_count++;
			}
		});

		if (traveler_count > 1) {
			$selected_travelers.html(sp_html);
			$('.selected-traveler-client-ids').html(spcid_html);
			$form.find('.no-travelers-selected').addClass('hidden');
			$selected_travelers.removeClass('hidden');

			$selected_travelers.find('.remove-all').on('click', function click(e) {
				_resetSelectedTravelers();
			});

			$selected_travelers.find('.remove').on('click', function click(e) {
				_removeSelectedTraveler($(e.target).parent());
				_buildSelectedTravelers();
			});

			if (drake !== null) {
				drake.destroy();
			}

			drake = dragula(
				[$form.find('.selected-travelers')[0]],
				{
					moves: function moves(el, source, handle, sibling) {
						return $(el).hasClass('draggable');
					},
				}
			)
			.on('drop', function over(el) {
				setTimeout(function timeout() {
					travelers = [];

					$selected_travelers.find('.remove').each(function iterator(i, span) {
						var $span = $(this);

						travelers.push({
							type     : $span.data('type'),
							client_id: $span.data('client-id').toString(),
							name     : $span.data('name'),
						});
					});

					_buildSelectedTravelers();
				}, 0);
			});

		} else {
			$selected_travelers.addClass('hidden');
			$form.find('.no-travelers-selected').removeClass('hidden');
			$('.selected-traveler-client-ids').html('');
		}
	};

	_removeSelectedTraveler = function _removeSelectedTraveler($selected_traveler)
	{
		if ($selected_traveler.data('type') === 'recommended') {
			$('.recommended-traveler[value=' + $selected_traveler.data('client-id') + ']').prop('checked', false);
		}

		$.each(travelers, function iterator(i, traveler) {
			if (typeof traveler !== 'undefined' && traveler['client_id'] === $selected_traveler.data('client-id').toString()) {
				delete travelers[i];

				return false;
			}
		});
	};

	_removeSelectedTravelerByClientId = function _removeSelectedTravelerByClientId(client_id)
	{
		$.each(travelers, function iterator(i, traveler) {
			if (typeof traveler !== 'undefined' && traveler['client_id'] === client_id.toString()) {
				delete travelers[i];

				return false;
			}
		});

		_buildSelectedTravelers();
	};

	_resetSelectedTravelers = function _resetSelectedTravelers()
	{
		$form.find('.selected-travelers').find('.remove').each(function iterator(i, selected_traveler) {
			_removeSelectedTraveler($(selected_traveler));
		});

		_buildSelectedTravelers();
	};

	Adzuki.Erez.SearchAddTraveler = SearchAddTraveler;

}(jQuery, window.Adzuki || {}));
